<template>
  <div class="container-list">
    <ul class="tab-wrap">
      <li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index, tab)" v-for="(tab, index) in tabList">
        {{ tab }}
      </li>
    </ul>
    <div class="flex" style="height:90%">
      <div class="flex1">
        <mapInfo v-if="nowIndex == 0" :marker="markers"></mapInfo>
        <info :c_num="$route.query.id" v-if="nowIndex == 1"></info>
        <!-- <jiejingdtList v-if="nowIndex==1"></jiejingdtList> -->
        <company :c_num="$route.query.id" v-if="nowIndex == 2"></company>
        <checkrecord :c_num="$route.query.id" v-if="nowIndex == 3"> </checkrecord>
        <saferecord :c_num="$route.query.id" v-if="nowIndex == 4"></saferecord>
        <facilty :c_num="$route.query.id" v-if="nowIndex == 5" />
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";
import mapInfo from "./jiejingMap.vue";
import jiejingdtList from "./jiejingdtList.vue";

import facilty from "../facility/facilty.vue";

import company from "./companyinfo";
import checkrecord from "./checkRecord.vue";
import saferecord from "./xuncharecord.vue";
import info from "./info.vue";
// import tab2 from "./tab2.vue";
// import tab3 from "./tab3.vue";
// import tab4 from "./tab4.vue";
// import tab5 from "./tab5.vue";
// import tab6 from "./tab6.vue";
// import tab7 from "./tab7.vue";
// import tab8 from "./tab8.vue";
// import tab9 from "./tab9.vue";
// import tab10 from "./tab10.vue";

export default {
  components: {
    unitList,
    mapInfo,
    jiejingdtList,
    facilty,
    checkrecord,
    company,
    saferecord,
    info,
  },
  data() {
    return {
      nowIndex: this.$route.query.index || 0,
      cpNum: "",
      nowid: "",
      tabList: ["地图信息", "火警信息", "基本信息", "查岗记录", "巡检记录", "设备信息"],
      markers: [],
    };
  },
  created() {
    if (this.$route.query.id) {
      this.getList();
    }
  },
  mounted() {},
  methods: {
    changeTab(index, it) {
      this.nowIndex = index;
      this.nowid = it.tr_role_key;
    },
    getList() {
      this.$post("/user/areabasedetail", { c_company_num: this.$route.query.id }).then((res) => {
        var arr = [];
        var obj = {};
        var item = res.data;
        obj.position = [Number(item.lon), Number(item.lat)];

        (obj.showmod = true),
          (obj.text = `<div> <span style='font-size:12px'>${item.c_name}</span></div>
                                   
                                               `);
        obj.c_company_num = item.c_company_num;

        arr.push(obj);
        this.markers = arr;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
.container-list {
  height: 100%;
}
</style>
